// src/components/Episodes/EpisodeCard.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { usePlayer } from '../../contexts/PlayerContext';
import LazyImage from '../LazyImage/LazyImage';
import { buildSubscriberSignInPath, isSubscriberOnlyContent } from '../../utils/subscriberAccess';
import './EpisodeCard.css';

const EpisodeCard = ({ episode }) => {
  const navigate = useNavigate();
  const { canAccessExclusiveContent } = useAuth();
  const { playEpisode, currentEpisode, isPlaying } = usePlayer();

  const episodeSlug = episode.slug || `episode-${episode.id}`;
  const detailPath = `/episode/${episodeSlug}`;
  const isLocked = isSubscriberOnlyContent(episode) && !canAccessExclusiveContent;
  const destination = isLocked ? buildSubscriberSignInPath(detailPath) : detailPath;

  const handlePlayClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isLocked) {
      navigate(destination);
      return;
    }

    playEpisode({
      id: episode.id,
      title: episode.title,
      audioUrl: episode.audio_url,
      thumbnailUrl: episode.thumbnail_url || episode.itunes_image
    });
  };

  // Check if this episode is currently playing
  const isCurrentEpisode = currentEpisode && currentEpisode.id === episode.id;
  const isThisEpisodePlaying = isCurrentEpisode && isPlaying;
  return (
    <article className={`a-card ${isThisEpisodePlaying ? 'is-playing' : ''} ${isLocked ? 'is-locked' : ''}`}>
      <div className="a-thumb">
        <Link className="a-thumb__link" to={destination} aria-label={`View ${episode.title}`}>
          <LazyImage episode={episode} size="medium" alt={episode.title} />
        </Link>
        {isLocked ? <span className="a-card__badge">Members</span> : null}
        <button
          type="button"
          className="a-thumb__play"
          onClick={handlePlayClick}
          aria-label={isLocked ? `Unlock ${episode.title}` : `${isThisEpisodePlaying ? 'Pause' : 'Play'} ${episode.title}`}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            {isLocked ? (
              <><path d="M7 10V7a5 5 0 0 1 10 0v3" /><path d="M5 10h14v11H5zM12 14v3" /></>
            ) : isThisEpisodePlaying ? (
              <path d="M9 7v10M15 7v10" />
            ) : (
              <path d="m9 6 9 6-9 6Z" />
            )}
          </svg>
        </button>
      </div>
      <Link className="a-card__body" to={destination}>
        <h4>{episode.title}</h4>
        <p>
          {episode.episode_number ? `EP${episode.episode_number}` : ''}
          {episode.episode_number && episode.itunes_duration ? ' · ' : ''}
          {episode.itunes_duration || ''}
        </p>
        {episode.show?.title ? <span className="a-card__show">{episode.show.title}</span> : null}
      </Link>
    </article>
  );
};

export default EpisodeCard;
